import { Fade } from "@progress/kendo-react-animation";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";
import { useEffect } from "react";
import { notification } from "../Common/Store/CommonSignals";

function NotificationControl() {
  useEffect(() => {
    if (notification.value.show) {
      const timer = setTimeout(() => {
        notification.value = { ...notification.value, show: false };
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [notification.value.show]);

  const handleClose = () => {
    notification.value = { ...notification.value, show: false };
  };

  return notification.value.show ? (
    <NotificationGroup
      style={{
        top: 15,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10000,
      }}
    >
      <Fade
        enter={true}
        exit={true}
      >
        <Notification
          type={{
            style: notification.value.type,
            icon: true,
          }}
          style={{
            minHeight: "100px",
            width: "300px",
            maxWidth: "400px",
            fontSize: "20px",
          }}
          closable={true}
          onClose={handleClose}
        >
          <span>{notification.value.message}</span>
        </Notification>
      </Fade>
    </NotificationGroup>
  ) : null;
}

export default NotificationControl;
